import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["headerText", "bodyText", "desktopImage", "mobileImage", "textColor", "textDesktopAlignment", "icon", "iconAlt"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Banner/Banner.js",
  _this = this;
import React from 'react';
import { Column, Spacing } from '../../index';
import { StyledEmptyContentContainer, StyledBodyText, StyledGrid, StyledHeaderText, StyledIconImage, StyledRow, StyledTextContainer, Wrapper } from './style';
import { testIdProps } from '../../helpers';
var renderIcon = function renderIcon(icon, iconAlt) {
  var MobileIcon = icon;
  if (typeof MobileIcon === 'string') {
    return /*#__PURE__*/React.createElement(StyledIconImage, {
      src: icon,
      alt: iconAlt,
      "data-testid": "bannerIconImage",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 20,
        columnNumber: 7
      }
    });
  }
  return /*#__PURE__*/React.createElement(MobileIcon, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 10
    }
  });
};
var Banner = function Banner(_ref) {
  var headerText = _ref.headerText,
    bodyText = _ref.bodyText,
    desktopImage = _ref.desktopImage,
    mobileImage = _ref.mobileImage,
    textColor = _ref.textColor,
    _ref$textDesktopAlign = _ref.textDesktopAlignment,
    textDesktopAlignment = _ref$textDesktopAlign === void 0 ? 'left' : _ref$textDesktopAlign,
    icon = _ref.icon,
    iconAlt = _ref.iconAlt,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    desktopImage: desktopImage,
    mobileImage: mobileImage
  }, testIdProps(rest), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(StyledGrid, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(StyledRow, {
    reverse: textDesktopAlignment === 'left',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Column, {
    xs: 12,
    sm: 6,
    noGutter: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(StyledEmptyContentContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(Column, {
    xs: 12,
    sm: 6,
    noGutter: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(StyledTextContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 13
    }
  }, icon && /*#__PURE__*/React.createElement(React.Fragment, null, renderIcon(icon, iconAlt), /*#__PURE__*/React.createElement(Spacing, {
    top: 4,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 19
    }
  })), headerText && /*#__PURE__*/React.createElement(StyledHeaderText, {
    type: "bannerTitle",
    "data-testid": "bannerHeaderText",
    color: textColor,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 17
    }
  }, headerText), bodyText && /*#__PURE__*/React.createElement(StyledBodyText, {
    type: "body",
    "data-testid": "bannerBodyText",
    color: textColor,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 17
    }
  }, bodyText))))));
};
export default Banner;